import React, { useRef, useState } from 'react';
import Modal from 'react-modal';
import { useData } from "../../components/context/DataContext";
import 'video.js/dist/video-js.css';
import VideoJS from './VideoJS';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { useVideoModal, useVideoModalUpdate, useVideoID }  from "../context/ModalContext";

import './VideoPopupModal.css';
import 'video.js/dist/video-js.css';

const VideoPopupModal = () => {

  const dataState = useData();

  const videoArray = [
    {"video": "1_Understanding_biologic_and_biosimilar_medicines.mp4", "poster": "poster.jpg"},
    {"video": "2_Biosimilar_manufacturing_considerations.mp4", "poster": "poster.jpg"},
    {"video": "3_Key_steps_of_a_biosimilar_development_program.mp4", "poster": "poster.jpg"},
    {"video": "4_Extrapolation_in_biosimilar_medicines.mp4", "poster": "poster.jpg"},
    {"video": "5_The_impact_of_multiple_sclerosis_on_the_healthcare_system.mp4", "poster": "poster.jpg"},
    {"video": "6_Biosimilar_medicines_and_the_healthcare_system.mp4", "poster": "poster.jpg"},
    {"video": "7_Biosimilar_treatment_switch_what_you_need_to_know.mp4", "poster": "poster.jpg"},
    {"video": "8_Unraveling_the_nocebo_effect_strategies_to_maximize_treatment_acceptability.mp4", "poster": "poster.jpg"},
  ]

  const vidid = useVideoID()

  const videoJsOptions = {
    poster: require('../../assets/video/' + videoArray[vidid].poster),
    class: "video-js vjs-default-skin vjs-big-play-centered vjs-show-big-play-button-on-pause",
    autoplay: false,
    controls: true,
    responsive: true,
    fluid: true,
    sources: [{
    src: require('../../assets/video/' + videoArray[vidid].video),
    type: 'video/mp4'
    }]
  };

  
    const videoModalState = useVideoModal(true);
    const setVideoModalState = useVideoModalUpdate();
    const [isVisible, setIsVisible] = useState(false);

    Modal.setAppElement('#root')

    const customStyles = {
        overlay: {
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          padding: 40,
          backgroundColor: 'rgba(0, 0, 0, 0.8)',
          zIndex: 1000
        },
        content : {
          position: 'relative',
          background: '#FFFFFF',
          inset: 0,
          margin: 20,
          overflow: 'unset',
          border: "none",
          borderTopRightRadius: 4,
          maxWidth: "800px",
          width: "100%"
        }
      };

      function closeModal(){
        setVideoModalState(false);
        setIsVisible(false);
      }

      function afterOpenModal(){
        // fireArrayReset();
      }

      function afterClose(){
        // fireArrayReset();
      }

    return (
      <Modal
            closeTimeoutMS={0}
            isOpen={ videoModalState }
            onAfterOpen={afterOpenModal}
            onAfterClose={afterClose}
            onRequestClose={closeModal}
            style={customStyles}
            contentLabel="Example Modal"
            id="react-modal-video-623"
            >
              <div className="modal-header-transparent video-head">
                <div className="modal-title"><h2>{dataState && dataState.items[vidid].label}</h2></div>
                <div className="close-btn-transparent" onClick={closeModal}><FontAwesomeIcon icon={faTimes} /></div>
              </div>
              <VideoJS options={videoJsOptions} />

        </Modal>
    );
};


export default VideoPopupModal;